import { render } from "./PhotoViewer.vue?vue&type=template&id=ee039976&scoped=true"
import script from "./PhotoViewer.vue?vue&type=script&lang=js"
export * from "./PhotoViewer.vue?vue&type=script&lang=js"

import "./photo-viewer.scss?vue&type=style&index=0&id=ee039976&lang=scss&scoped=true"

import exportComponent from "/Users/nisalatp/Projects/Herd/OrangeHRM/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee039976"]])

export default __exports__